import { Images } from 'assets/images';

export const QUESTIONS_DATA = [
  {
    id: 12,
    title: 'Reece',
    position: '5',
    answer_type: 'Radio-button',
    visibility: 'On',
  },
  {
    id: 14,
    title: 'Yerevan, Armenia',
    position: '2',
    answer_type: 'checkbox',
    visibility: 'Off',
  },
];

export const SYSTEM_USERS_DATA = [
  {
    id: 122,
    name: 'Hayko',
    email: 'hayk@elitedevsquad.com',
    birthdate: '2023/02.15',
    blocked: 'No',
    role: 'operator',
  },
  {
    id: 129,
    name: 'Sargis',
    email: 'sargis@elitedevsquad.com',
    birthdate: '2023/02.12',
    blocked: 'Yes',
    role: 'Admin',
  },
];

export const CUSTOMERS_DATA = [
  {
    id: 122,
    name: 'Hayko',
    email: 'hayk@elitedevsquad.com',
    birthdate: '2023/02.15',
    blocked: 'No',
    request_limit: 2,
    role: 'operator',
  },
  {
    id: 129,
    name: 'Sargis',
    email: 'sargis@elitedevsquad.com',
    birthdate: '2023/02.12',
    blocked: 'Yes',
    request_limit: 3,
    role: 'Admin',
  },
];

export const ALL_REQUESTS_DATA = [
  {
    id: '63',
    name: 'Hayko Kirakosyan',
    status: 'In Progress',
    operator: 'Ruben Petrosyan',
    received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
];

export const MY_REQUEST_DATA = [
  {
    id: '63',
    name: 'Tigran Hambardzumyan',
    status: 'In Progress',
    operator: 'Ruben Petrosyan',
    received: '2023/01/17 01:14',
    sent: '2023/01/17 01:14',
  },
];

export const ANSWER_DATA = [
  {
    labelKey: 'Label Key',
    id: '0',
    labelValue: 'Label Value',
    password_eye: false,
  },
];

export const PLACEHOLDER_DATA = [
  {
    placeholder: 'Label Key',
    value: 'Label Value',
    id: '0',
  },
];

export const ANSWER_OPTIONS = {
  checkbox: 'Checkbox',
  dropDown: 'Dropdown',
  multiple_choice: 'Multiple Choice',
  calendar: 'Calendar',
  item_counter: 'Item Counter',
};

export const ROLES = {
  admin: 'Admin',
  operator: 'Operator',
  user: 'User',
};

export const BLOCKED_OR_NOT = [
  { value: 'No', label: 'No' },
  { value: 'Yes', label: 'Yes' },
];

export const REQUEST_DATA = [
  {
    id: 1,
    question: 'sjsjnxsdnc djsncjsjsdsxcdc',
    answer:
      'Elit ea vel officia obcaecati labore quo ipsum rerum, Elit ea vel officia lit ea vel officia obcaecati labore quo ipsum rerum, Elit ea vel officia lit ea vel officia obcaecati labore quo ipsum rerum, Elit ea vel officia lit ea vel officia obcaecati labore quo ipsum rerum, Elit ea vel officia obcaecati labore quo ipsum rerum',
  },
  {
    id: 3,
    question: 'Where do you want to travel',
    answer: 'All over the world',
  },
];

export const _CONSTANT_BIRTH = '2023/01/17 01:30';

export const ON = 'On';
export const OFF = 'Off';
export const TEXT = 'text';
export const PASSWORD = 'password';
export const BLOCKED = 'Yes';
export const NOT_BLOCKED = 'No';
export const BLOCKED_TEXT = 'blocked';
export const VISIBILITY_TEXT = 'visibility';

export const ACTIVE_TABS = {
  CUSTOMERS: 'customers',
  SYSTEM_USERS: 'system-users',
  QUESTIONS: 'questions',
  PACKAGES: 'packages',
  HOT_OFFERS: 'hot-offers',
};

export const SHOW_CONTENT_NUMBERS = [
  { value: 10 },
  { value: 25 },
  { value: 50 },
  { value: 100 },
];

export const THREE_DOTS = '...';

export const MODAL_CONSTANTS = {
  ADD_USER: 'add-user',
  EDIT_USER: 'edit-user',
  ALL_REQUESTS: 'all-requests',
  MY_REQUESTS: 'my-requests',
  HOT_OFFERS: 'hot-offers',
};

export const CLASSNAMES = {
  BLOCKED: 'Yes',
  NOT_BLOCKED: 'No',
  ACTIVE: 'active',
  INACTIVE: 'inActive',
  PAGINATION_ITEMS_CLASSNAMES: 'PrevPageLink PageLinks NextPageLink',
  PAGINATOR_PAGE: 'p-paginator-page',
};

export const REACT_HOOK_FORM_NAMES = {
  question: 'question',
  position: 'position',
  title: 'title',
  answer_type: 'answer_type',
  label_key: 'label_key',
  placeholder: 'placeholder',
  placeholder_value: 'value',
};

export const SUGGESTION_DATA = [
  {
    id: 1,
    title: 'Lionel Messi',
    main_image: Images.bali,
    description:
      'Lionel Andrés Messi, also known as Leo Messi, is an Argentine professional' +
      ' footballer who plays as a forward for Ligue 1 club Paris' +
      ' Saint-Germain and captains the Argentina national team.',
  },

  {
    id: 2,
    title: 'Cristiano Ronaldo',
    main_image: Images.bali,
    description:
      'Cristiano Ronaldo dos Santos Aveiro GOIH ComM is a Portuguese professional' +
      ' footballer who plays as a forward for and captains both Saudi' +
      ' Professional League club Al Nassr and the Portugal national team.',
  },

  {
    id: 3,
    title: 'Erling Halland',
    main_image: Images.bali,
    description:
      'Erling Braut Haaland is a Norwegian professional footballer who' +
      ' plays as a striker for Premier League club Manchester City ' +
      'and the Norway national team. Considered one of the best players ' +
      'in the world, he is known for his speed, strength and finishing inside the',
  },

  {
    id: 4,
    title: 'Kilian Mbappe',
    main_image: Images.bali,
    description:
      'Kylian Mbappé Lottin is a French professional footballer' +
      ' who plays as a forward for Ligue 1 club Paris Saint-Germain' +
      ' and the France national team. Considered one of the best players' +
      ' in the world, he is renowned for his dribbling abilities, exceptional speed, and finishing',
  },
];

export const PROFILE_MODAL_CONSTANTS = {
  changePassword: 'change-password',
  logOut: 'log-out',
  deleteAccount: 'delete-account',
};
